import styled from 'styled-components';

export const ContainerIcon = styled.div`
  top: 5px;
  color: var(--bottom-color-sefaz);
  cursor: pointer;
  font-size: 2.6rem;
`;

export const IconButton = styled.div`
  cursor: pointer;
  font-size: 16pt;
  margin: 0 5px 0px 5px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  button {
    margin-right: 10px;
    margin-top: 10px;
  }
`;

export const TextoNome = styled.span`
  font-size: 15pt;
  color: var(--bottom-color-sefaz);
  font-weight: 500;
`;
export const TextoDocumento = styled.p`
  font-size: 12pt;
  margin: 0px;
  color: var(--bottom-color-sefaz);
`;

export const TextoPerfil = styled.p`
  font-size: 10pt;
  margin: 0 0 0 7px;
  color: var(--bottom-color-sefaz);
`;
